import { useMutation } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";
import type { RecommendGeniePageContentResult } from "@/types/genie-documents/genie-document";

/**
 * Draft a Genie Page's owner-editable content — hero copy, owner-written
 * sections, contact details — from the genie's knowledge sources. The page
 * twin of `useRecommendQuestions`, with one difference: nothing is persisted
 * server-side, so there is no query to invalidate. The editor keeps the ideas
 * in local state and the owner applies them through the normal save path.
 */
export const useRecommendPageContent = () =>
  useMutation<RecommendGeniePageContentResult, Error, string>({
    mutationFn: async (agentId) =>
      ApiService.invoke<RecommendGeniePageContentResult>({
        resource: "genie-documents",
        action: "recommend-page-content",
        data: { agentId },
      }),
  });
